export default {
	diyCheckout(form, cb, ecb, config) {
		this.http
			.post('/shop/diyCheckout', form, config)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getRootCategory(shopid, cb, ecb) {
		this.http
			.get(`/shop/getRootCategory/${shopid}`, {})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getItemStocks(shopid, itemid, cb, ecb) {
		this.http
			.get(`/shop/stocksOf/${shopid}/${itemid}`, {})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getItemStock(shopid, id, sku, cb, ecb) {
		this.http
			.get(`/shop/stockOf/${shopid}/${id}/` + JSON.stringify(sku), {})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getItemStock2(shopid, stockid, cb) {
		this.http.get(`/shop/getItemStock/${shopid}/${stockid}/`, {}).then((r) => cb && cb(r))
	},
	getItemsByTag(shopid, tag, cb, ecb) {
		this.http
			.get(`/shop/getItemsByTag/${shopid}/${tag}`, {})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	updateControlQtys(shopid, qtys, cb) {
		this.http.post(`/shop/updateControlQtys/${shopid}`, { qtys }).then((r) => cb && cb(r))
	},
	getDiyMenu(shopid, cb) {
		this.http.get(`/shop/getDiyMenu/${shopid}`, {}).then((r) => cb && cb(r))
	},
	getDiyMenu2(shopid, cb) {
		this.http.get(`/shop/getDiyMenu2/${shopid}`, {}).then((r) => cb && cb(r))
	},
	getDiyCategory(shopid, id, cb, ecb) {
		this.http
			.get(`/shop/getDiyCategory/${shopid}/${id}`, {})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getDeliveryTypes(shopid, cb, pointid = '') {
		this.http.get(`/shop/getDeliveryTypes/${shopid}/${pointid}`, {}).then((r) => cb && cb(r))
	},
	getDeliveryFee(shopid, dt, params, cb, ecb) {
		this.http
			.post(`/shop/getDeliveryFee/${shopid}/${dt}`, params)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getPurchaseMenu(type, cb) {
		this.http.get(`/shop/getPurchaseMenu/${type}`, {}).then((r) => cb && cb(r))
	},
	stockin(form, cb, ecb, config = {}) {
		this.http
			.post(`/shop/stockin/`, form, config)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	stockout(form, cb, ecb, config = {}) {
		this.http
			.post(`/shop/stockout/`, form, config)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getById(id, cb, ecb, config) {
		this.http
			.get(`/shop/getById/${id}`, config)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getByIds(ids, cb, ecb, config) {
		this.http
			.get(`/shop/getByIds/${ids}`, config)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getByLocation(latlng, cb, ecb, config = {}) {
		this.http
			.get(`/shop/getByLocation/${latlng}`, config)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	searchOrder(params, cb, ecb) {
		this.http
			.get(`/shop/searchOrder`, { params })
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	search(params, cb, ecb) {
		this.http
			.get('/shop/search', {
				params
			})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	update(form, cb, ecb) {
		this.http
			.post('/shop/update', form)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getUsers(shopid, cb, ecb) {
		this.http
			.get(`/shop/getUsers/${shopid}`, {})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getShopsByUser(uid, cb) {
		this.http.get(`/shop/getShopsByUser/${uid}`).then((r) => cb && cb(r))
	},
	getUserGroup(shopid, cb, ecb) {
		this.http
			.get(`/shop/getUserGroup/${shopid}`, {})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getStockRequest(shopid, params, cb, ecb) {
		http2
			.get(`/shop/${shopid}/stockrequest`, {
				params
			})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	//定制门店菜单
	getMenu(shopid, params, cb) {
		this.http
			.get(`/shop/getMenuByShop/${shopid}`, {
				params
			})
			.then((r) => cb && cb(r))
	},
	searchMenu(params, cb, ecb) {
		this.http
			.get(`/shop/searchMenu`, {
				params
			})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getMenuById(menuid, cb) {
		this.http.get(`/shop/getMenuById/${menuid}`, {}).then((r) => cb && cb(r))
	},
	updateMenu(form, cb, ecb = null) {
		this.http
			.post('/shop/updateMenu', form)
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	//门店账户管理
	getAccountById(id, cb) {
		this.http.get(`/shop/account/${id}`, {}).then((r) => cb && cb(r))
	},
	searchAccount(params, cb, ecb) {
		this.http
			.get('/shop/account', {
				params
			})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	updateAccount(form, cb, ecb = null) {
		this.http
			.post('/shop/account', form)
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	removeAccount(id, cb, ecb = null) {
		this.http
			.delete(`/shop/account/${id}`)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	searchAccountLog(params, cb, ecb) {
		this.http
			.get('/shop/accountlog', {
				params
			})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getAccountLogById(id, cb) {
		this.http.get(`/shop/accountlog/${id}`, {}).then((r) => cb && cb(r))
	},
	searchStockLogItem(shopid, skuid, cb) {
		this.http.get(`/shop/searchStockLogItem/${shopid}/${skuid}`, {}).then((r) => cb && cb(r))
	},
	getPointById(ids, cb, ecb, config) {
		this.http
			.get(`/shop/getPointById/${ids}`, config)
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	getMenuById(id, cb, ecb = null) {
		this.http
			.get(`/shop/getMenuById/${id}`, {})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	searchPoint(params, cb, ecb) {
		this.http
			.get('/shop/searchPoint', {
				params
			})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	searchMenu(params, cb, ecb) {
		this.http
			.get('/shop/searchMenu', {
				params
			})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	searchMenuItem(params, cb, ecb) {
		this.http
			.get('/shop/searchMenuItem', {
				params
			})
			.then((r) => cb && cb(r))
			.catch((e) => ecb && ecb(e))
	},
	statusMenuItem(shopid, to, cb) {
		this.http.get(`/shop/statusMenuItem/${shopid}/${to}`, {}).then((r) => cb && cb(r))
	},
	changeState(shopid, to, cb) {
		this.http.get(`/shop/changeState/${shopid}/${to}`, {}).then((r) => cb && cb(r))
	}
}
